export interface LabeledOption {
  value: string;
  label: string;
  /** Unavailable, but still visible — not removed from the list. */
  disabled?: boolean;
}

/**
 * Expands a choice list that accepts plain strings as shorthand for
 * `{ value, label }` — shared by every hh-* component that takes a
 * `(T | string)[]` list (hh-select's options, hh-tabs' tabs).
 */
export function normalizeLabeledOptions<T extends LabeledOption>(items: (T | string)[]): T[] {
  return items.map((item) => (typeof item === 'string' ? ({ value: item, label: item } as T) : item));
}
